import { combineReducers } from '@reduxjs/toolkit';
import MenuReducer from './menu/reducer';

const CommonReducer = combineReducers({
  menu: MenuReducer,
});

export default CommonReducer;
